import type { TBoard } from '../types';
import { COLS, ROWS } from '../constants';

export function getValidColumns(board: TBoard): number[] {
  const columns: number[] = [];

  for (let col = 0; col < COLS; col++) {
    if (board[0][col] === null) {
      columns.push(col);
    }
  }

  return columns;
}

export function getDropRow(board: TBoard, col: number): number {
  for (let row = ROWS - 1; row >= 0; row--) {
    if (board[row][col] === null) {
      return row;
    }
  }
  return -1;
}
